import axios from 'axios';

// Use relative URL in production, full URL in development
const API_URL = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const sessionApi = {
  /**
   * Create a new session
   */
  createSession: async () => {
    const response = await api.post('/sessions');
    return response.data;
  },

  /**
   * Open a session for a code: joins the existing session, or creates it under
   * that code if it no longer exists. Returns { success, created }.
   */
  ensureSession: async (sessionId) => {
    const response = await api.post(`/sessions/${sessionId}/ensure`);
    return response.data;
  },

  /**
   * Get QR code for a session
   */
  getQRCode: async (sessionId) => {
    const response = await api.get(`/sessions/${sessionId}/qr`);
    return response.data;
  },

  /**
   * Upload a file to a session
   */
  uploadFile: async (sessionId, file, socketId, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('socketId', socketId);

    const response = await api.post(`/sessions/${sessionId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });

    return response.data;
  },

  /**
   * Get download URL for a file
   */
  getDownloadUrl: (sessionId, fileId) => {
    return `${API_URL}/api/sessions/${sessionId}/download/${fileId}`;
  },

  /**
   * Get session data (files and texts)
   */
  getSessionData: async (sessionId) => {
    const response = await api.get(`/sessions/${sessionId}/data`);
    return response.data;
  },
};

export default api;
